import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        if (setUser) setUser(r.data.user);
        // clean hash
        window.history.replaceState(null, "", window.location.pathname);
        if (r.data.user?.is_admin) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/admin/login", { replace: true });
        }
      } catch (e) {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center text-white/90">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full border-2 border-[#D4AF37] border-t-transparent animate-spin"/>
        <p className="mt-4 font-serif text-white">Stepping into the sanctuary…</p>
      </div>
    </div>
  );
}
